module.exports = __webpack_public_path__ + "img/p2.66b36a74.jpg";